// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import App from "./app.vue";
import Vue2Filters from "vue2-filters";
import { ToastPlugin } from "bootstrap-vue";
import router from "./router";
import * as config from "./shared/config/config";
import * as bootstrapVueConfig from "./shared/config/config-bootstrap-vue";
import JhiItemCountComponent from "./shared/jhi-item-count.vue";
import JhiSortIndicatorComponent from "./shared/sort/jhi-sort-indicator.vue";
import InfiniteLoading from "vue-infinite-loading";
import HealthService from "./admin/health/health.service";
import MetricsService from "./admin/metrics/metrics.service";
import LogsService from "./admin/logs/logs.service";
import ConfigurationService from "@/admin/configuration/configuration.service";
import ActivateService from "./account/activate/activate.service";
import RegisterService from "./account/register/register.service";
import LoginService from "./account/login.service";
import AccountService from "./account/account.service";
import "normalize.css/normalize.css";
import "roboto-fontface/css/roboto-condensed/roboto-condensed-fontface.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/brands.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";
import VueCompositionAPI from "@vue/composition-api";
import vuetify from "./plugins/vuetify";
import "./core/filter/date";

import TranslationService from "@/locale/translation.service";

import UserOAuth2Service from "@/entities/user/user.oauth2.service";
/* tslint:disable */
import PublicationService from "@/entities/publication/publication.service";
import TagService from "@/entities/tag/tag.service";
import CustomerService from "@/entities/customer/customer.service";
import CampaignService from "@/entities/campaign/campaign.service";
import CampaignLinkService from "@/entities/campaign-link/campaign-link.service";
import LandingNewsService from "@/entities/landing-news/landing-news.service";
import ApiService from "@/entities/api/api.service";
import { store } from "./store";
import ClientService from "./admin/client/client.service";
import SponsorTagService from "@/entities/sponsor-tag/sponsor-tag.service";
import MeasuringService from "@/entities/measuring/measuring.service";
import ReportService from "@/entities/report/report.service";
import NotificationRuleService from "@/entities/notification-rule/notification-rule.service";
import { Chart, registerables } from "chart.js";
import UserService from "@/admin/client/user.service";
import LogEntryService from "@/entities/log-entry/log-entry.service";
// import {Chart, LinearScale, LineController, LineElement, PointElement, Title} from "chart.js";
// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
Vue.use(ToastPlugin);
Vue.use(VueCompositionAPI);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("jhi-item-count", JhiItemCountComponent);
Vue.component("jhi-sort-indicator", JhiSortIndicatorComponent);
Vue.component("infinite-loading", InfiniteLoading);
const i18n = config.initI18N(Vue);

const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, router);

Chart.register(...registerables);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next("/not-found");
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        sessionStorage.setItem("requested-url", to.fullPath);
        if (accountService.authenticated) {
          next("/forbidden");
        } else {
          next("/login");
        }
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
export const VUE = new Vue({
  el: "#app",
  components: { App },
  template: "<App/>",
  router,
  vuetify,
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    registerService: () => new RegisterService(),
    healthService: () => new HealthService(),
    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),

    userOAuth2Service: () => new UserOAuth2Service(),
    translationService: () => translationService,
    publicationService: () => new PublicationService(),
    clientService: () => new ClientService(),
    customerService: () => new CustomerService(),
    campaignService: () => new CampaignService(),
    campaignLinkService: () => new CampaignLinkService(),
    landingNewsService: () => new LandingNewsService(),
    logEntryService: () => new LogEntryService(),
    apiService: () => new ApiService(),
    tagService: () => new TagService(),
    sponsorTagService: () => new SponsorTagService(),
    measuringService: () => new MeasuringService(),
    reportService: () => new ReportService(),
    notificationRuleService: () => new NotificationRuleService(),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    userService: () => new UserService()
  },
  i18n,
  store
});
